import * as api from '../../redux/api/actions.js'

import { Link } from 'react-router-dom'
import { withRouter } from '../../utils/withRouterCompat'
import React, { Component } from 'react'

import Alert from '@mui/material/Alert'
import Backdrop from '@mui/material/Backdrop'
import Box from '@mui/material/Box'
import { Button } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress'
import Container from '@mui/material/Container'
import CssBaseline from '@mui/material/CssBaseline'
import TextField from '@mui/material/TextField'
import Typography from '@mui/material/Typography'
import ZoetisLogo from '../../assets/img/logo_corte.png'
import { connect } from 'react-redux'
import { resetPassword } from '../../redux/auth/actions.js'

class ResetPassword extends Component {
  constructor(props) {
    super(props)

    const { email, token, invite } = Object.fromEntries(
      new URLSearchParams(this.props.location.search)
    )

    this.state = {
      email: email,
      invite: invite,
      token: token.replace(/\+/g, '%2B').replace(/\//g, '%2F'),
      newpassword: '',
      confirmPassword: ''
    }

    this.handleChange = this.handleChange.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
  }

  handleChange = event => {
    const {
      target: { name, value }
    } = event
    this.setState(() => ({ [name]: value }))
  }

  async handleSubmit() {
    const result = await this.props.resetPassword(this.state)
    if (result.hasErrors) {
      this.setState({ errorMessage: result.title })
    } else {
      this.props.history.push('/login')
    }
  }

  canSubmit() {
    return (
      this.state.email &&
      this.state.token &&
      this.state.password &&
      this.state.confirmPassword &&
      this.state.password === this.state.confirmPassword
    )
  }

  render() {
    if (this.props.loading) {
      return (
        <Backdrop open>
          <CircularProgress color='inherit' />
        </Backdrop>
      )
    }

    return (
      <>
        <CssBaseline />
        <Box
          sx={{
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            bgcolor: 'background.default',
            px: 2,
            py: 4,
          }}
        >
          <Container maxWidth='xs' disableGutters>
            <Box
              sx={{
                bgcolor: 'background.paper',
                borderRadius: 2,
                boxShadow: 1,
                p: { xs: 3, sm: 4 },
              }}
            >
                <Typography component='div'>
                  <img
                    src={ZoetisLogo}
                    alt='Zoetis Gerar'
                    style={{
                      width: '100%'
                    }}
                  />

                  {this.props.error && (
                    <Alert
                      severity='error'
                      style={{
                        marginTop: '1em'
                      }}
                    >
                      {this.props.error.title}
                    </Alert>
                  )}

                  {this.props.success && (
                    <Alert
                      severity='success'
                      style={{
                        marginTop: '1em'
                      }}
                    >
                      {Boolean(this.state.invite) === true
                        ? 'Senha definida com sucesso!'
                        : 'Senha alterada com sucesso!'}
                    </Alert>
                  )}

                  <Container disableGutters>
                    <Container
                      disableGutters
                      style={{
                        marginTop: '1em'
                      }}
                    >
                      <h4 style={{ marginBottom: 12 }}>
                        {' '}
                        {Boolean(this.state.invite) === true
                          ? 'Primeiro Acesso'
                          : 'Recuperação de Senha'}{' '}
                      </h4>
                      <TextField
                        id='login-form-password'
                        label='Nova senha'
                        name='password'
                        variant='outlined'
                        type='password'
                        onChange={this.handleChange}
                        style={{
                          width: '100%',
                          backgroundColor: 'white'
                        }}
                      />
                    </Container>
                    <Container
                      disableGutters
                      style={{
                        marginTop: '1em'
                      }}
                    >
                      <TextField
                        id='login-form-confirm-password'
                        label='Confirmar Senha'
                        name='confirmPassword'
                        variant='outlined'
                        type='password'
                        onChange={this.handleChange}
                        style={{
                          width: '100%',
                          backgroundColor: 'white'
                        }}
                      />
                    </Container>
                    <Container
                      disableGutters
                      style={{
                        marginTop: '1em'
                      }}
                    >
                      <Button
                        variant='contained'
                        color='primary'
                        disableElevation
                        size='large'
                        style={{
                          width: '100%'
                        }}
                        disabled={!this.canSubmit()}
                        onClick={this.handleSubmit}
                      >
                        Enviar
                      </Button>
                      <Box
                        fontWeight='fontWeightLight'
                        style={{
                          marginTop: '1em',
                          textAlign: 'center'
                        }}
                      >
                        <Link
                          to='/login'
                          style={{
                            color: '#333',
                            textDecoration: 'none'
                          }}
                        >
                          voltar
                        </Link>
                      </Box>
                    </Container>
                  </Container>
                </Typography>
            </Box>
          </Container>
        </Box>
      </>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    resetPassword: params => dispatch(resetPassword(params))
  }
}

const mapStateToProps = state => ({
  loading: api.getApiLoading(state, `Account/ResetPassword`),
  error: api.getApiError(state, `Account/ResetPassword`) || false,
  success: api.getApiResult(state, `Account/ResetPassword`) || false
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(ResetPassword))
